import React from "react";
import Nav from "../../components/Navbar/Nav";
import Banner from "../../components/Banner/Banner";
import requests from "../../api/Requests";
import Row from "../../components/Movies/Row";

function NewPopular() {
	return (
		<div className="homeScreen">
			<Nav />
			<Banner fetchUrl={requests.fetchTrendingWeek} />
			<div className="row-container">
				<Row title="Trending Today" fetchUrl={requests.fetchTrendingDay} isLargeRow />
				<Row title="Trending This Week" fetchUrl={requests.fetchTrendingWeek} isLargeRow />
				<Row title="Trending Movies" fetchUrl={requests.fetchTrendingMovies} isLargeRow />
				<Row title="Trending TV Shows" fetchUrl={requests.fetchTrendingTV} isLargeRow />
				<Row title="Now Playing" fetchUrl={requests.fetchNowPlaying} isLargeRow />
				<Row title="Upcoming Movies" fetchUrl={requests.fetchUpcoming} isLargeRow />
				<Row title="On The Air" fetchUrl={requests.fetchOnTheAir} isLargeRow />
				<Row title="Airing Today" fetchUrl={requests.fetchAiringToday} isLargeRow />
			</div>
		</div>
	);
}

export default NewPopular;
